import React, { useState } from 'react';
import DueDateFilterView from '../view/DueDateFilterView';
import getUTCNoonForDate from '../../../utils/getUTCNoonForDate';

export const BASIC_OPTIONS = [
  {
    text: 'Today',
    id: 'today'
  },
  {
    text: 'Next 7 days',
    id: 'next_7_days'
  },
  {
    text: 'Next 30 days',
    id: 'next_30_days'
  },
  {
    text: 'Overdue',
    id: 'overdue'
  },
  {
    text: 'Date range',
    id: 'custom_range'
  }
];

const DueDateFilterEngine = ({ value = {}, counts = {}, onChange }) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [checkedOptions, setCheckedOptions] = useState(
    value.checkedOptions || []
  );
  const [displayValue, setDisplayValue] = useState(
    BASIC_OPTIONS.filter(one => checkedOptions.includes(one.id))
      .map(one => one.text)
      .join(', ') || 'Due date'
  );
  const [areDateRangesEnabled, setAreDateRangesEnabled] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const onClicked = e => {
    setAnchorEl(e.currentTarget);
    setOpen(true);
  };
  const toggleOption = v => {
    let newCheckedOptions = [...checkedOptions];
    let callbackObject = {};
    if (checkedOptions.includes(v)) {
      newCheckedOptions = newCheckedOptions.filter(one => one !== v);
    } else {
      newCheckedOptions.push(v);
    }
    let newDisplayValue =
      BASIC_OPTIONS.filter(one => newCheckedOptions.includes(one.id))
        .map(one => one.text)
        .join(', ') || '';
    callbackObject.checkedOptions = newCheckedOptions;
    callbackObject.fromDate = fromDate;
    callbackObject.toDate = toDate;

    onChange(callbackObject);
    setAreDateRangesEnabled(newCheckedOptions.includes('custom_range'));
    setCheckedOptions(newCheckedOptions);
    setDisplayValue(newDisplayValue || 'Due date');
  };
  const parseDate = date => {
    let parsedDate = new Date(date);
    if (date === 'now') {
      return null;
    }

    if (!(parsedDate instanceof Date && !isNaN(parsedDate))) {
      parsedDate = new Date(parseInt(date));
    }
    return parsedDate;
  };
  const updateFromDate = dateValue => {
    const newVal = getUTCNoonForDate(dateValue);
    let callbackObject = { checkedOptions: [...checkedOptions] };
    callbackObject.fromDate = newVal;
    callbackObject.toDate = toDate;
    onChange(callbackObject);
    setFromDate(newVal);
  };
  const updateToDate = dateValue => {
    const newVal = getUTCNoonForDate(dateValue);
    let callbackObject = { checkedOptions: [...checkedOptions] };
    callbackObject.fromDate = fromDate;
    callbackObject.toDate = newVal;
    onChange(callbackObject);
    setToDate(newVal);
  };
  const viewProps = {
    anchorEl,
    areDateRangesEnabled,
    checkedOptions,
    dateCounts: counts?.date || {},
    displayValue,
    fromDate,
    toDate,
    updateFromDate,
    updateToDate,
    onClicked,
    open,
    parseDate,
    setOpen,
    toggleOption
  };

  return <DueDateFilterView {...viewProps} />;
};

export default DueDateFilterEngine;
